// صفحةُ مراجعة الحضور (pages/attendance-review.tsx) — 2026-10-27.
const EN_B18: Record<string, string> = {
  "أعِد احتساب الرواتب ليُطبَّق — لا احتساب ولا اعتماد آلي.":
    "Recompute payroll to apply it — nothing is recomputed or approved automatically.",
  "لم يُحفظ":
    "Not saved",
  "إلغاء القرار يعيد اليوم للمراجعة. لا يغيّر البصمات.":
    "Revoking the decision returns the day to review. Punches are not changed.",
  "يُعفي {n} دقيقة فقط — ليس حضوراً كاملاً ولا يغيّر البصمات.":
    "Excuses {n} minutes only — not full attendance, and punches are not changed.",
  "أعيّن هذا اليوم خارج أيام الغياب المحسوبة. الغياب يبقى {a} من {u} مرشّحين. يُخصم تأخيره {n} دقيقة{amt}.":
    "I assign this day outside the charged absence days. Absence stays {a} of {u} candidate days. Its lateness of {n} minutes is deducted{amt}.",
  "{n} دقيقة ناقصة تُخصم مرة واحدة{amt} (الأساسي ÷ 26 ÷ 8 ÷ 60).":
    "{n} missing minutes deducted once{amt} (basic ÷ 26 ÷ 8 ÷ 60).",
  "مراجعة الحضور":
    "Attendance review",
  "فترة الرواتب":
    "Payroll period",
  "سماح ١٥ دقيقة بتصديق المالك مطبَّق على السجلات السابقة":
    "15-minute grace from the owner's attestation applies to earlier records",
  "تصديق المالك غير مطبَّق: سجل التدقيق يخالفه":
    "Owner's attestation not applied: the audit log contradicts it",
  "المبالغ مخفية — لا صلاحية رواتب":
    "Amounts hidden — no payroll permission",
  "لا أيام تحتاج مراجعة في هذه الفترة.":
    "No days need review in this period.",
  "الغياب المحسوب {a} من {u} أيام مرشّحة — يتّسع «خارج الغياب» لـ{s} يوم، مستعمل {d}.":
    "Charged absence {a} of {u} candidate days — room for {s} day(s) “outside absence”, {d} used.",
  "محجوب":
    "Blocked",
  "محسوم":
    "Decided",
  "يحتاج قرار":
    "Needs a decision",
  "(قرار سابق لم يعد مطابقاً للدقائق الحالية)":
    "(an earlier decision no longer matches the current minutes)",
  "البصمات":
    "Punches",
  "استئذان":
    "Permission",
  "قبول بعذر":
    "Accept with excuse",
  "اعتماد الخصم":
    "Approve deduction",
  "إلغاء القرار":
    "Revoke decision",
  "السبب (إلزامي)":
    "Reason (required)",
  "قُبل بعذر":
    "Accepted with excuse",
  "اعتُمد الخصم":
    "Deduction approved",
  "سماح غير معروف":
    "Unknown grace",
  "تأخير على يوم مرشّح للغياب":
    "Lateness on a candidate absence day",
  "استئذان جزئي ببصمة مفتوحة":
    "Partial permission with an open punch",
  "دقائق مخزّنة تخالف البصمات":
    "Stored minutes contradict punches",
  "جلسات متداخلة":
    "Overlapping sessions",
  "سماح التأخير وقت البصمة غير محفوظ، فلا يُعرف كم من هذه الدقائق سماح.":
    "The grace at punch time is not stored, so it is unknown how many of these minutes were grace.",
  "لا يُعرف أي الأيام هو الغياب المحسوب، فلا يُعرف هل يُخصم تأخير هذا اليوم.":
    "It is unknown which day is the charged absence, so it is unknown whether this day's lateness is deducted.",
  "تعيينات «خارج الغياب» أكثر مما يتّسع — ألغِ أحدها.":
    "More “outside absence” assignments than there is room for — revoke one.",
  "سماح البصمة المحفوظ يخالف تصديق المالك — يحتاج تصحيح دليل مستقل، لا قرار هنا.":
    "The stored punch grace contradicts the owner's attestation — needs a separate evidence correction, not a decision here.",
  "غموض الاستئذان الجزئي خارج دعم هذه الصفحة — يبقى محجوباً.":
    "Partial-permission ambiguity is outside this page's support — it stays blocked.",
  "الدقائق المخزّنة تخالف أوقات البصمة — صحّح السجل أولاً.":
    "Stored minutes contradict punch times — correct the record first.",
  "جلسات متداخلة جزئياً بلا مرجع — صحّح السجل أولاً.":
    "Partially overlapping sessions without a reference — correct the record first.",
  "تصديق المالك لهذا اليوم منقوض بسجل التدقيق — لا قرار عام يتجاوزه.":
    "The owner's attestation for this day is contradicted by the audit log — no general decision can override it.",
  "قرار سابق لم يعد مطابقاً لبيانات الحضور أو الراتب — ألغِه.":
    "An earlier decision no longer matches the attendance or salary data — revoke it.",
  "تغيّرت بيانات الحضور أو الاستئذان أو المناوبة أو الراتب بعد القرار — لا يُطبَّق حتى يُعاد القرار.":
    "Attendance, permission, shift or salary data changed after the decision — it does not apply until decided again.",
  "تغيّرت قواعد الحساب بعد القرار — لا يُطبَّق حتى يُعاد القرار.":
    "The calculation rules changed after the decision — it does not apply until decided again.",
  "تغيّرت حدود الفترة بعد القرار — لا يُطبَّق حتى يُعاد القرار.":
    "The period bounds changed after the decision — it does not apply until decided again.",
  "لا يدخل الحساب":
    "not counted",
  "بصمة":
    "Punch",
  "إجازة أيام":
    "Day leave",
  "سجل القرارات":
    "Decision history",
};
export default EN_B18;
